<template>
  <div class="oldproduct">
    <div class="header">
      <i class="iconfont icon-return" @click="$router.back(-1)"></i>
      <span>{{title}}</span>
    </div>
    <div class="progress">
      <div class="step-progress" :style="'width:'+line+'%'"></div>
      <span class="text">
        ! 温馨提示，按顺序如实描述最终回收价格更相近
        <span class="stepnum">{{line>99?100:line}}%</span>
      </span>
    </div>
    <div v-if="product.product.goodsId>0">
      <Laptop
        :product="product"
        :attrheight="attrheight"
        @setStep="setStep"
        @getAttr="getAttr"
        v-if="product.product.catId==19"
      />
      <Watch
        :product="product"
        @setStep="setStep"
        @getAttr="getAttr"
        v-else-if="product.product.catId==15"
      />
      <Phone
        :product="product"
        :attrheight="attrheight"
        @setStep="setStep"
        @getAttr="getAttr"
        v-else
      />
    </div>
    <div class="product-footer">
      <button class="ahs-track-click" @click="onAssess" :class="step >= total ?'':'disabled'">免费询价</button>
    </div>
  </div>
</template>

<script>
import Phone from "@/components/Mobile/OldProduct/Phone.vue";
import Laptop from "@/components/Mobile/OldProduct/Laptop.vue";
export default {
  data() {
    return {
      step: 0,
      realstep: 0,
      line: 0,
      count: 0,
      isnew: 2,
      attrs: [],
      total: 1,
      attrid: 0,
      title: "评估详情",
      height: 0,
      attrheight: []
    };
  },
  components: {
    Phone,
    Laptop
  },
  computed: {
    product() {
      return this.$store.state.oldproduct.product;
    }
  },
  mounted: function() {
    window.scrollTo(0, 0);
    let autoheight = 0;
  },
  created() {
    this.fetchListData();
  },
  methods: {
    fetchListData() {
      this.$toast.loading("加载中...");

      let params = { id: this.$route.params.id };
      let autoheight = 0;
      this.$store
        .dispatch("oldproduct/fetchProductData", { params })
        .then(() => {
          document.title = this.product.product.goodsName;
          this.title = this.product.product.goodsName;
          this.count = 100 / (this.product.attrValue.length - 1);
          this.total = this.product.attrValue.length - 1;
          for (let i = 0; i < this.product.attrValue.length - 1; i++) {
            let height = this.product.attrValue[i].valueList.length * 60 + 50;
            autoheight += height;
            this.attrheight.push(autoheight);
          }
          this.$toast.clear();
        });
    },
    setStep(step) {
      this.step = step;
      let line = this.count;
      this.line = parseInt(line * this.step);
    },
    getAttr(data) {
      this.attrs = data;
    },
    onAssess() {
      let goodsId = this.product.product.goodsId;
      let params = {
        goodsId: goodsId,
        attrvalueId: this.attrs.join(",")
      };
      this.$toast.loading("估价中...");
      this.$store.dispatch("assess/fetchAssessData", { params }).then(() => {
        if (this.$store.state.assess.assess.assessAmount > 0) {
          window._hmt.push([
            "_trackEvent",
            "获取评估价格",
            "点击",
            this.$store.state.assess.assess.goodsName,
            this.$store.state.assess.assess.assessAmount
          ]);
          let id = this.$store.state.product.product.id
          localStorage.assess = JSON.stringify(this.$store.state.assess.assess);
          this.$router.push({ name: "mobileproduct", params: { id: id } });
        } else {
          this.$toast("估价失败,请稍后再试.");
        }
        this.$toast.clear();
      });
    }
  }
};
</script>

<style scoped>
.oldproduct {
  width: 100%;
  height: auto;
  font-size: 0.14rem;
  overflow: hidden;
  padding: 0.7rem 0 1rem 0;
}
.progress {
  width: 3.75rem;
  height: 0.3rem;
  background: #f0f0f0;
  position: fixed;
  top: 0.39rem;
  z-index: 999;
}
.header {
  width: 3.75rem;
  height: 0.4rem;
  line-height: 0.4rem;
  background: #fff;
  text-align: center;
  position: fixed;
  top: 0;
  z-index: 999;
  overflow: hidden;
}
.header .icon-return {
  position: absolute;
  left: 0.1rem;
}
.progress .text {
  position: absolute;
  left: 0rem;
  top: 0rem;
  font-size: 0.12rem;
  height: 0.3rem;
  line-height: 0.3rem;
  color: #333;
  text-align: center;
  width: 100%;
}
.step-progress {
  width: 0px;
  background: linear-gradient(90deg, #ff8787, #ff4747);
  height: 0.3rem;
  transition: width 0.5s;
}
.product-footer {
  width: 3.75rem;
  display: block;
  position: fixed;
  bottom: 0;
  height: 0.45rem;
  box-shadow: #ccc 0 0 5px;
  background: #fff;
}
.ahs-track-click {
  width: 90%;
  display: block;
  margin: 0.05rem auto;
  background: #ff4747;
  color: #fff;
  font-size: 16px;
  line-height: 0.35rem;
  text-align: center;
  cursor: pointer;
  border: 0;
}
.ahs-track-click:hover {
  color: #fff;
}
.ahs-track-click.disabled {
  background: #bababa !important;
  pointer-events: none;
  cursor: default;
}
</style>
